module.exports = __webpack_public_path__ + "media/images/social/facebook-7279fde4fa718a751ed08c02ab500ab8.svg";